import {Pipe, PipeTransform} from '@angular/core'

@Pipe({name: 'replace'})

export class ReplacePipe implements PipeTransform {
  public transform(value: string): string {
    return value.toLowerCase().replace(/ /g, '_')
  }
}
